import { createAction, createSlice } from '@reduxjs/toolkit';
import { sortBy, uniqBy } from 'lodash';
import type { DateYMDString } from '@lt/api/dist/types/date';

import type {
  PriceChartState,
  SetPriceChartAction,
  PaginationDirectionAction,
} from './types';

const initialState: PriceChartState = {
  result: [],
  isFetching: false,
  direction: null,
};

const priceChart = createSlice({
  name: 'priceChart',
  initialState,
  reducers: {
    setPriceChart: (state, action: SetPriceChartAction) => {
      const uniqResult = uniqBy(action.payload.result, 'start_date');
      const sortingResult = sortBy(uniqResult, 'start_date');

      state.result = sortingResult;
      state.isFetching = false;
      state.direction = null;
    },
    paginationDirection: (state, action: PaginationDirectionAction) => {
      state.direction = action.payload;
    },
    fetching: (state) => {
      state.isFetching = true;
    },
  },
});

export const { setPriceChart, fetching, paginationDirection } =
  priceChart.actions;

export const fetchPriceChart = createAction<{ startDate: DateYMDString }>(
  `${priceChart.name}/fetchPriceChart`,
);

export const { name } = priceChart;

export default priceChart.reducer;
